import { render } from "./SalesMultiCustomer.vue?vue&type=template&id=990abfb6&scoped=true"
import script from "./SalesMultiCustomer.vue?vue&type=script&lang=js"
export * from "./SalesMultiCustomer.vue?vue&type=script&lang=js"

import "./SalesMultiCustomer.vue?vue&type=style&index=0&id=990abfb6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-990abfb6"]])

export default __exports__